// Транслитерация кириллицы в латиницу и построение URL-слага.
// Используется, чтобы показывать ФИО врача латиницей в адресной строке (/form/<slug>).

const TRANSLIT_MAP: Record<string, string> = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh',
  з: 'z', и: 'i', й: 'y', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o',
  п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'kh', ц: 'ts',
  ч: 'ch', ш: 'sh', щ: 'shch', ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu',
  я: 'ya',
  // Казахские буквы
  ә: 'a', ғ: 'g', қ: 'q', ң: 'n', ө: 'o', ұ: 'u', ү: 'u', һ: 'h', і: 'i',
}

/** Переводит кириллический текст в латиницу. Латиница/цифры остаются как есть. */
export function transliterate(input: string): string {
  return Array.from(input)
    .map((ch) => {
      const lower = ch.toLowerCase()
      const mapped = TRANSLIT_MAP[lower]
      if (mapped === undefined) return ch
      if (ch === lower || mapped === '') return mapped
      return mapped.charAt(0).toUpperCase() + mapped.slice(1)
    })
    .join('')
}

/** Строит URL-слаг латиницей в нижнем регистре: "Иванов Иван" → "ivanov-ivan". */
export function slugify(input: string): string {
  return transliterate(input)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
